/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260429
*/
'use strict';


import {
    getPropNmAndKey
} from './ctssArrayUtils.js';
import {
    addDays
} from './ctssDateTime.js'
import {
    getHtmlDateInputVal
} from './ctssFormat.js';
import {
    getTableRows
} from './ctssHtml.js';
import {
    allSettled,
    deletePromise,
    getPromise,
    savePromise
} from './ctssJQuery.js';
import {
    enableBtn,
    hasCheckedItems,
} from './ctssVal.js';
import {
    getGroupsToolBarMenuItem,
    initGroupCtrlsAsync,
    initGroupsDDL
} from './snGroupCtrls.js';
import {
    getMuteIconText,
    getMuteMsg,
    getUnMuteMsg,
    toggleMutedAsync
} from './snMembersManagement.js';
import {
    appDebugMode,
    defaultProfileImg,
    getAppToken,
    getTestFolderParams,
    Features,
    setMenu
} from './snSite.js';

/* private functions */

const { useTestFolder, testFolderParam } = getTestFolderParams();

const token = getAppToken();

const deletePrayerAsync = async (params) => {
    await deletePromise({
        url: `Prayers/${token.CG}/${token.sub}/${params.id}/true`,
        divErrMsg: 'divDelDlgErrMsg',
    }).then(() => {
        $('#deleteDlg').modal('hide');
        /* Just removing from page is faster than going to server to refresh */
        prayers.splice(prayers.findIndex(x => x.id === params.id), 1);
        refreshPrayersGrid();
    });
}

const refreshPrayersGrid = () => {
    pendingApprovalHdr = false;
    publicApprovedHdr = false;
    justStaffHdr = false;

    const prayerFilter = $('#ddlPrayerFilter').val();
    const data = [];

    if (hasGroups) {
        const groupID = Number($('#hiddenToolBarGroupID').val());
        if (groupID === -1) { /*All Groups */
            if (prayerFilter === "1") { /* Pending Approval - All Groups */
                data.push(...prayers.filter(x => x.isApproved === false && x.justStaff === false));
            } else if (prayerFilter === "2") { /* Just Staff - All Groups */
                data.push(...prayers.filter(x => x.justStaff === true));
            } else { /* Show All - All Groups */
                data.push(...prayers);
            }
        } else { /* Add groupID to filter */
            if (prayerFilter === "1") { /* Pending Approval - Group */
                data.push(...prayers.filter(x => x.isApproved === false && x.justStaff === false && x.gid === groupID));
            } else if (prayerFilter === "2") { /* Just Staff - Group */
                data.push(...prayers.filter(x => x.justStaff === true && x.gid === groupID));
            } else { /* Show All - Group */
                data.push(...prayers.filter(x => x.gid === groupID));
            }
        }
        getTableRows({ arr: data, fnGetRow: getPrayerRow, gridNm: 'gridPrayers' });

        $('#gridPrayers .grpImg').off('error').on('error', (e) => {
            e.target.src = `${testFolderImgsBaseURL}${e.target.dataset.img_name}`;
        });

    } else {
        if (prayerFilter === "1") { /* Pending Approval */
            data.push(...prayers.filter(x => x.isApproved === false && x.justStaff === false));
        } else if (prayerFilter === "2") { /* Just Staff */
            data.push(...prayers.filter(x => x.justStaff === true));
        } else { /* Show All */
            data.push(...prayers);
        }
        getTableRows({ arr: data, fnGetRow: getNoGroupsPrayerRow, gridNm: 'gridPrayers' });
    }
    $('#gridPrayers .profileImg').off('error').on('error', (e) => {
        e.target.src = defaultProfileImg;
    });

}

const getMutedMGsAsync = async () =>
    await getPromise({ url: `MembersManagement/${token.CG}/MutedMGs` });    

const getPrayersDataAsync = async () => {

    /* Retrieve prayers for all groups if user is admin or group prayers for group leader */

    const gids = (token.IsAdmin !== "True" && hasGroups && token.GroupLeaderRights.length > 0)
        ? `?gids=${await snGroupLeaders.getGroupLeaderGroupIDsAsync({})}`
        : '';

    return await getPromise({ url: `Prayers/${token.CG}${gids}` });
}

const getNoGroupsPrayerRow = (params = {}) => {

    if (!params.data) {
        alert('data is a required parameter for getNoGroupsPrayerRow');
        return '';
    }

    const {
        id,
        by = by ?? '',
        description,
        editedDesc,
        dtReq,
        isApproved,
        justStaff,
        postUntil,
        sub
    } = params.data;

    let row = '';
    if (!pendingApprovalHdr && !isApproved && !justStaff) {
        row += '<tr><td colspan="5" class="col-md-12 grpHdr">Pending approval</td></tr>';
        pendingApprovalHdr = true;
    } else if (!publicApprovedHdr && isApproved) {
        row += '<tr><td colspan="5" class="col-md-12 grpHdr">Approved for church</td></tr>';
        publicApprovedHdr = true;
    } else if (!justStaffHdr && justStaff) {
        row += '<tr><td colspan="5" class="col-md-12 grpHdr">Seen by church staff only</td></tr>';
        justStaffHdr = true;
    }

    const dtR = new Date(dtReq),
        sDtReq = (dtR.getUTCMonth() + 1) + '/' + dtR.getUTCDate() + '/' + dtR.getUTCFullYear(),
        dt = new Date(postUntil),
        sDt = (dt.getUTCMonth() + 1) + '/' + dt.getUTCDate() + '/' + dt.getUTCFullYear(),
        prayerDesc = editedDesc ?? description;


    row += `<tr id="${id}" >` +
        `<td class="col-md-7"><div class="text-center"><strong>${sub}</strong></div>`;

    if (isApproved === false && justStaff === false) {
        row += `<table><tbody><tr><td>` +
            `<input id="cb_${id}" type="checkbox" class="k-checkbox"` +
            'onclick="snPrayers.enableApproveBtn()" >' +
            `<label for="cb_${id}" class="k-checkbox-label"></label>` +
            `</td><td class="mLeft25">${prayerDesc}</td></tr></tbody></table></td>`;
    } else {
        row += prayerDesc + '</td>';
    }

    row += `<td class="col-md-2">${by}</td>` +
        `<td class="col-md-1 text-right"><table><tbody><tr><td>${sDtReq}</td><td></td></tr>` +
        `<tr><td><span id="postUntil_${id}">${sDt}</span></td>` +
        `<td><span class="fa fa-calendar mLeft10" data-toggle="modal" data-target="#dateDlg" data-key="${id}" ></span></td></tr></tbody></table></td>`;
    if (justStaff) {
        row += '<td class="col-md-1 text-center"><span class="fa fa-users" title="Only church staff should be aware of this prayer"></span></td>';
    } else {
        row += '<td class="col-md-1 text-center"><span class="fa fa-globe" title="Public prayer"></span></td>';
    }
    row += '<td class="col-md-1 text-right">';

    const mute = getMuteIconText({ isMuted: isMemberMuted(mg) });

    row += `<span class="fa ${mute.icon} mRight10" title="${mute.title}" data-toggle="modal" data-target="#muteDlg" data-key="${mg}"></span>`;
    row += `<span class="fa fa-pencil mRight10" title="Edit and approve prayer..." data-toggle="modal" data-target="#editDlg" data-key="${id}"></span>`;
    row += `<span class="fa fa-trash" title="Delete prayer..." data-toggle="modal" data-target="#deleteDlg" data-key="${id}"></span>` +
        `</td></tr>`;

    return row;
}

const getPrayerRow = (params) => {

    if (!params.data) {
        alert('data is a required parameter for getsPrayerRow');
        return '';
    }

    const {
        id,
        by = by ?? '',
        byImgURL = byImgURL ?? '',
        description,
        editedDesc,
        dtReq,
        gid,
        isApproved,
        justStaff,
        mg,
        postUntil,
        sub
    } = params.data;

    let row = '';
    if (!pendingApprovalHdr && !isApproved && !justStaff) {
        row += '<tr><td colspan="6" class="col-md-12 grpHdr">Pending approval</td></tr>';
        pendingApprovalHdr = true;
    } else if (!publicApprovedHdr && isApproved && !justStaff) {
        row += '<tr><td colspan="6" class="col-md-12 grpHdr">Approved for church</td></tr>';
        publicApprovedHdr = true;
    } else if (!justStaffHdr && justStaff) {
        row += '<tr><td colspan="6" class="col-md-12 grpHdr">Seen by church staff only</td></tr>';
        justStaffHdr = true;
    }

    const dtR = new Date(dtReq),
        sDtReq = (dtR.getUTCMonth() + 1) + '/' + dtR.getUTCDate() + '/' + dtR.getUTCFullYear(),
        dt = new Date(postUntil),
        sDt = (dt.getUTCMonth() + 1) + '/' + dt.getUTCDate() + '/' + dt.getUTCFullYear(),
        prayerDesc = !editedDesc ? description : editedDesc;


    row += `<tr id="${id}" >`;

    //const g = groupMenuItems[groupMenuItems.findIndex(x => x.value === gid.toString())];
    const g = groups[groups.findIndex(x => x.value === gid.toString())];

    if (g !== undefined) {
        row +=
            '<td class="col-md-1 imgDesc-circle-sm" style="padding-left: 10px; vertical-align: middle;">' +
            `<img class="grpImg" src="${g.imgSrc}" data-img_name="${g.imgName}"></td>` +
            `<td class="col-md-6"><div class="text-center"><strong>${sub}</strong></div>`;
    } else {
        row += `<td class="col-md-1> </td><td class="col-md-6> </td>` +
            `<td class="col-md-6"><div class="text-center"><strong>${sub}</strong></div>`;
    }

    if (isApproved === false && justStaff === false) {
        row += '<table><tbody><tr><td>' +
            `<input id="cb_${id}" type="checkbox" class="k-checkbox"` +
            'onclick="snPrayers.enableApproveBtn()" >' +
            `<label for="cb_${id}" class="k-checkbox-label"></label>` +
            `</td><td class="mLeft25">${prayerDesc}</td></tr></tbody></table></td>`;
    } else {
        row += prayerDesc + '</td>';
    }

    row += `<td class="col-md-2 imgDesc-circle-sm"><img class="profileImg" src="${byImgURL}"></span >${by}</td>` +
        `<td class="col-md-1 text-right"><table><tbody><tr><td>${sDtReq}</td><td></td></tr>` +
        `<tr><td><span id="postUntil_${id}">${sDt}</span></td>` +
        `<td><span class="fa fa-calendar mLeft10" data-toggle="modal" data-target="#dateDlg" data-key="${id}" ></span></td></tr></tbody></table></td>`;
    if (justStaff) {
        row += '<td class="col-md-1 text-center"><span class="fa fa-users" title="Only church staff should be aware of this prayer"></span></td>';
        row += '<td></td></tr>';
    } else {
        row += '<td class="col-md-1 text-center"><span class="fa fa-globe" title="Public prayer"></span></td>';
        row += '<td class="col-md-1 text-right">';

        const mute = getMuteIconText({ isMuted: isMemberMuted(mg) });

        row += `<span class="fa ${mute.icon} mRight10" title="${mute.title}"
                data-toggle="modal" data-target="#muteDlg" data-key="${mg}"></span>`;
        row += `<span class="fa fa-pencil mRight10" title="Edit and approve prayer..." data-toggle="modal" data-target="#editDlg" data-key="${id}"></span>`;
        row += `<span class="fa fa-trash" title="Delete prayer..." data-toggle="modal" data-target="#deleteDlg" data-key="${id}"></span>` +
            `</td></tr>`;
    }
    return row;
}

const initAddPrayer = () => {
    $('#btnAddPrayer').click(async () => {

        const dtReq = new Date(),
            gid = hasGroups ? parseInt($('#hiddenGroupID').val(), 10) : 0,
            postUntil = addDays(dtReq, 30);

        const newPrayer = {
            gid: gid,
            dType: 120,
            cg: token.CG,
            mg: token.sub,
            by: token.FirstName + ' ' + token.LastName,
            byImgURL: token.ProfileImgURL,
            sub: $('#editTitle').val(),
            description: $('#editDescription').val(),
            dtReq: dtReq,
            postUntil: postUntil
        };

        await savePrayerAsync({ prayer: newPrayer })
            .then(async () => {
                try {
                    prayers = await getPrayersDataAsync();
                    refreshPrayersGrid();

                } catch (error) { }
            });
        $('#addDlg').modal('hide');
    });
}

const initDateDlg = () => {
    $('#dateDlg').on('show.bs.modal', (e) => {
        const key = e.relatedTarget.dataset.key;
        const prayer = prayers.find(x => x.id === key);
        $('#postUntil').val(getHtmlDateInputVal({ datestr: prayer.postUntil }));
        $('#btnChangeDate').off('click').click(async () => {

            const dt = new Date($('#postUntil').val());
            $('#postUntil_' + key).text(
                (dt.getUTCMonth() + 1) + '/' + dt.getUTCDate() + '/' + dt.getUTCFullYear()
            );
            prayer.postUntil = dt.toISOString();

            await savePrayerAsync({
                prayer: prayer,
                divErrMsg: 'divDateDlgErrMsg'
            }).then(() => $('#dateDlg').modal('hide'));
        });
    });
}

const initDeleteDlg = () => {
    $('#deleteDlg').on('show.bs.modal', (e) => {
        const key = e.relatedTarget.dataset.key;
        const prayer = prayers.find(x => x.id === key);
        $('#deletePrompt').text(`Are you sure you want to delete the '${prayer.sub}' prayer request?`);
        $('#btnDelete').off('click').click(async () => await deletePrayerAsync({ id: key }));
    });
}

const initEditDlg = () => {
    $('#editDlg').on('show.bs.modal', (e) => {
        const key = e.relatedTarget.dataset.key;
        const prayer = prayers.find(x => x.id === key);
        let prompt;
        if (hasGroups) {
            const menuItem = getGroupsToolBarMenuItem({ value: prayer.gid.toString() });
            prompt = menuItem === undefined
                ? `Edit prayer by ${prayer.by}?`
                : `Edit prayer by ${prayer.by} for ${menuItem.text}?`
        }
        else {
            prompt = `Edit prayer by ${prayer.by}?`
        }
        $('#editDlgLbl').text(prompt);
        $('#editedDesc').text(prayer.editedDesc ?? prayer.description);

        $('#btnEditSaveAndApprove').off('click').click(async () => {
            const editedDesc = $('#editedDesc').val();
            if (editedDesc !== prayer.description) {
                prayer.editedDesc = editedDesc;
            }
            prayer.isApproved = true;
            await savePrayerAsync({ prayer: prayer })
                .then(() => {
                    sortPrayers();
                    refreshPrayersGrid();
                });

            $('#editDlg').modal('hide');
        });
    });

}

const initMuteDlg = () => {
    $('#muteDlg').on('show.bs.modal', (e) => {
        const key = e.relatedTarget.dataset.key;
        const isMuted = isMemberMuted(key);
        const prayer = prayers.find(x => x.mg === key);
        $('#muteDlgLbl').text((isMuted ? 'Unmute ' : 'Mute ') + prayer.by + '?');
        $('#muteDlgPrompt').text(isMuted ? getUnMuteMsg({ name: prayer.by }) : getMuteMsg({ name: prayer.by }));
        $('#btnToggleMuted').off().on('click', async () => {
            await toggleMutedAsync({ mg: key, isMuted: !isMuted });
            isMuted ? mutedMGs.splice(mutedMGs.indexOf(key), 1, 0) : mutedMGs.push({ ID: '-99', MG: key });
            refreshPrayersGrid();
            $('#muteDlg').modal('hide');
        });
    });
}


const initPrayersGrid = () => {
    let content;
    if (hasGroups) {
        content = '<tr>' +
            '<th class="col-md-1">Group</th>' +
            '<th class="col-md-6">Prayer</th>' +
            '<th class="col-md-2"> By</th>' +
            '<th class="col-md=1"><div>Requested</div>Post Until</th>' +
            '<th class="col-md-1">Privacy</th>' +
            '<th class="col-md-1">' +
            '    <button class="btn btn-sm pull-right"' +
            '        data-toggle="modal" data-target="#addDlg">' +
            '        <span class="fa fa-plus"></span> Add Prayer' +
            '    </button>' +
            '</th>' +
            '</tr>';
    }
    else {
        content = '<tr>' +
            '<th class="col-md-7">' +
            '<div class="pull-left">' +
            '<label>Prayers</label>' +
            '<span class="fa fa-filter mLeft25 mRight5"></span>' +
            '<select id="ddlPrayerFilter" onchange="snPrayers.filterNoGroups(this.value);">' +
            '<option value="0">Show All</option>' +
            '<option value="1">Pending Approval</option>' +
            '<option value="2">Staff Only</option>' +
            '</select>' +
            '<button id="btnApprove" type="button" disabled ' +
            '        title="Approved checked prayers..." ' +
            '        class="btn btn-sm btn-default mLeft10"> ' +
            '    <span class="fa fa-thumbs-up"></span> Approve' +
            '</button>' +
            '</div >' +
            '</th>' +
            '<th class="col-md-2">By</th>' +
            '<th class="col-md=1"><div>Requested</div>Post Until</th>' +
            '<th class="col-md-1">Privacy</th>' +
            '<th class="col-md-1">' +
            '    <button class="btn btn-sm pull-right"' +
            '        data-toggle="modal" data-target="#addDlg">' +
            '        <span class="fa fa-plus"></span> Add Prayer' +
            '    </button>' +
            '</th>' +
            '</tr>';
    }
    $('#gridPrayers thead').empty().append(content);
}

const isMemberMuted = (mg) => mutedMGs.findIndex(x => x.MG === mg) > -1;

const savePrayerAsync = async (params) => {
    await savePromise({
        url: 'Prayers',
        data: params.prayer,
        divErrMsg: params.divErrMsg ?? 'divEditDlgErrMsg'   
    });
}
const sortPrayers = () => {
    prayers.sort((a, b) => {
        return a["justStaff"] - b["justStaff"] ||
            a["isApproved"] - b["isApproved"] ||
            b["dtReq"] - a["dtReq"];
    });
}
let gids = '';
let groupImgsBaseURL = '';
//let groupMenuItems = [];
let groups = [];
let hasGroups = false;
let mutedMGs = [];
let prayers = [];
let pendingApprovalHdr;
let publicApprovedHdr;
let justStaffHdr;
let testFolderImgsBaseURL = '';

const enableApproveBtn = () => {
    const isEnabled = hasCheckedItems({});
    enableBtn({ btnNm: '#btnApprove', isEnabled: isEnabled });
    if (isEnabled) {
        $('#btnApprove').off('click').click(() => {
            $('input[id^="cb_"]:checked').each(async function () {
                const id = getPropNmAndKey(this.id).key;
                const prayer = prayers.find(x => x.id === id);
                prayer.isApproved = true;
                await savePrayerAsync({ prayer });
            });
            sortPrayers();
            refreshPrayersGrid();
        });
    }
};

const initAsync = async () => {
    setMenu();
    initAddPrayer();
    initDateDlg();
    initDeleteDlg();
    initEditDlg();
    initMuteDlg();

    const groupsData = await initGroupCtrlsAsync({
        featureID: Features.PrayerRequests,
        useToolBar: true,
        useDDL: true,
        fnToolBarGroupDDLClick: () => { refreshPrayersGrid(); }
    });
    groupImgsBaseURL = groupsData.groupImgsBaseURL;
    //groupMenuItems = groupsData.toolBarMenuItems;
    groups = groupsData.groups;
    hasGroups = groupsData.hasGroups;
    testFolderImgsBaseURL = groupsData.testFolderImgsBaseURL;

    if (hasGroups) {
        const addedToolBarCtrls = '<label>Prayers</label><span class="fa fa-filter mLeft10"></span>' +
            '<select id="ddlPrayerFilter" class="mLeft10">' +
            '<option value="0">Show All</option>' +
            '<option value="1">Pending Approval</option>' +
            '<option value="2">Staff Only</option>' +
            '</select>' +
            '<button id="btnApprove" type="button" disabled title="Approved checked prayers..." ' +
            'class="btn btn-sm btn-default ib mLeft10">' +
            '<span class="fa fa-thumbs-up"></span> Approve' +
            '</button>';

        $('#groupsToolBar')
            .css('width', 660)
            .append(addedToolBarCtrls);

        $('#ddlPrayerFilter').on('change', () => { refreshPrayersGrid(); })

        $('#addDlg').on('show.bs.modal', async (e) => { 
            /* Initialize the model group DDL to the Group Toolbar DDL value */
             initGroupsDDL({
                featureID: Features.PrayerRequests,
                groupID: $('#hiddenToolBarGroupID').val()
            });
        });
    }

    //if (token.IsAdmin !== "True" && token.GroupLeaderRights.length > 0) {
    //    gids = await snGroupLeaders.getGroupLeaderGroupIDsAsync({}); 
    //}

    /* gids is used by getPrayersDataAsync() => '' = no groupIds or CSV of groupIds */

    const [prayersData, mutedData] = await allSettled({
        promises: [
            getPrayersDataAsync(),
            getMutedMGsAsync()
        ]
    });

    if (prayersData.status !== 'rejected' &&
        mutedData.status !== 'rejected') {
        prayers = prayersData.value;
        mutedMGs = mutedData.value;
        initPrayersGrid();
        refreshPrayersGrid();
    }
};


window.snPrayers = {
    enableApproveBtn,
    initAsync
};